import { useState, useEffect } from 'react';

// mui
import { Typography, Grid, Box } from '@mui/material';

// components
import { Footer } from '..';

// client-shared
import { storage } from '@goldblack/client-storage';
import { BlockedDialog, InactiveDialog } from '@goldblack/client-comps';

function UnauthorizedBody() {
    const [blockedOpen, setBlockedOpen] = useState(false);
    const [inactiveOpen, setInactiveOpen] = useState(false);
    const [expireDate, setExpireDate] = useState('');
    const blocked = storage.transience.getValue('internal.blocked');
    const inactive = storage.transience.getValue('internal.inactive');

    const onCloseBlocked = () => {
        setBlockedOpen(false);
    };

    const onCloseInactive = () => {
        setInactiveOpen(false);
    };

    useEffect(() => {
        setBlockedOpen(blocked ? true : false);
        setExpireDate(blocked ? new Date(blocked).toLocaleString('en-US') : '');
        setInactiveOpen(inactive);
    }, [blocked, inactive]);

    return (
        <Box sx={{ height: '100%' }}>
            <Grid
                container
                spacing={0}
                direction='column'
                justifyContent='center'
                alignItems='center'
                sx={{ height: '100%' }}>
                <Typography align='center' variant='m_logo' color='primary.main' sx={{ my: 5 }}>
                    Loise
                </Typography>
                <Footer />

                {/*===== blocked dialog =====*/}
                <BlockedDialog
                    open={blockedOpen}
                    onClose={onCloseBlocked}
                    onOK={onCloseBlocked}
                    expireDate={expireDate}
                />
                <InactiveDialog open={inactiveOpen} onClose={onCloseInactive} onOK={onCloseInactive} />
            </Grid>
        </Box>
    );
}

export { UnauthorizedBody };
